import { GraphQLWsLink } from '@apollo/client/link/subscriptions'

import { createClient } from 'graphql-ws'
import ReconnectingWebSocket from 'reconnecting-websocket'
import Utils from 'Utils'

type Props = { url: string }

export function createWsLink({ url }: Props) {
  const token = Utils.Auth.getAccessToken()

  const webSocketUrl = url.replace(/^http/, 'ws')

  return new GraphQLWsLink(
    createClient({
      url: webSocketUrl,
      webSocketImpl: ReconnectingWebSocket,
      connectionParams: () => ({
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }),
      lazy: true,
      on: {
        // eslint-disable-next-line no-console
        connected: () => console.log('[WS] connected'),
        // eslint-disable-next-line no-console
        closed: () => console.log('[WS] disconnected'),
      },
    }),
  )
}
